// Marketplace listings: discover-side list/get/preview + sell-side
// CRUD + buy-side subscribe/cancel + per-buyer subscriptions list +
// seller dashboards (my-listings, earnings).
//
// All in one action module so the UI imports one cohesive surface
// per page (browse, detail, manage). Reducers are split by purpose:
// see ../reducers/marketplace/*.

const ns = "MARKETPLACE_LISTINGS";

// ---- discover -----------------------------------------------------------
export const LIST_REQUEST    = ns + '_LIST_REQUEST';
export const LIST_RESPONSE   = ns + '_LIST_RESPONSE';
export const LIST_FAILURE    = ns + '_LIST_FAILURE';

export const DETAIL_REQUEST  = ns + '_DETAIL_REQUEST';
export const DETAIL_RESPONSE = ns + '_DETAIL_RESPONSE';
export const DETAIL_FAILURE  = ns + '_DETAIL_FAILURE';

export const PREVIEW_REQUEST  = ns + '_PREVIEW_REQUEST';
export const PREVIEW_RESPONSE = ns + '_PREVIEW_RESPONSE';
export const PREVIEW_FAILURE  = ns + '_PREVIEW_FAILURE';

// ---- sell-side mutations ------------------------------------------------
export const CREATE_REQUEST  = ns + '_CREATE_REQUEST';
export const CREATE_SUCCESS  = ns + '_CREATE_SUCCESS';
export const CREATE_FAILURE  = ns + '_CREATE_FAILURE';

export const UPDATE_REQUEST  = ns + '_UPDATE_REQUEST';
export const UPDATE_SUCCESS  = ns + '_UPDATE_SUCCESS';
export const UPDATE_FAILURE  = ns + '_UPDATE_FAILURE';

export const DELETE_REQUEST  = ns + '_DELETE_REQUEST';
export const DELETE_SUCCESS  = ns + '_DELETE_SUCCESS';
export const DELETE_FAILURE  = ns + '_DELETE_FAILURE';

// ---- buy-side -----------------------------------------------------------
export const SUBSCRIBE_REQUEST = ns + '_SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = ns + '_SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILURE = ns + '_SUBSCRIBE_FAILURE';

export const CANCEL_REQUEST    = ns + '_CANCEL_REQUEST';
export const CANCEL_SUCCESS    = ns + '_CANCEL_SUCCESS';
export const CANCEL_FAILURE    = ns + '_CANCEL_FAILURE';

export const SUBSCRIPTIONS_REQUEST  = ns + '_SUBSCRIPTIONS_REQUEST';
export const SUBSCRIPTIONS_RESPONSE = ns + '_SUBSCRIPTIONS_RESPONSE';
export const SUBSCRIPTIONS_FAILURE  = ns + '_SUBSCRIPTIONS_FAILURE';

// ---- seller dashboard ---------------------------------------------------
export const MY_LISTINGS_REQUEST  = ns + '_MY_LISTINGS_REQUEST';
export const MY_LISTINGS_RESPONSE = ns + '_MY_LISTINGS_RESPONSE';
export const MY_LISTINGS_FAILURE  = ns + '_MY_LISTINGS_FAILURE';

export const EARNINGS_REQUEST  = ns + '_EARNINGS_REQUEST';
export const EARNINGS_RESPONSE = ns + '_EARNINGS_RESPONSE';
export const EARNINGS_FAILURE  = ns + '_EARNINGS_FAILURE';

// Quick lookup: which signals in the active workspace are already
// published. Used by the Data Signals page to swap the publish
// affordance for a "Manage listing" affordance per signal.
export const PUBLISHED_SIGNALS_REQUEST  = ns + '_PUBLISHED_SIGNALS_REQUEST';
export const PUBLISHED_SIGNALS_RESPONSE = ns + '_PUBLISHED_SIGNALS_RESPONSE';
export const PUBLISHED_SIGNALS_FAILURE  = ns + '_PUBLISHED_SIGNALS_FAILURE';

// Verified-provider / publish-capability state for the current
// workspace + user. Drives every publish-to-marketplace affordance
// (hidden unless can_publish) and the Monetization application flow.
export const SELLER_STATUS_REQUEST  = ns + '_SELLER_STATUS_REQUEST';
export const SELLER_STATUS_RESPONSE = ns + '_SELLER_STATUS_RESPONSE';
export const SELLER_STATUS_FAILURE  = ns + '_SELLER_STATUS_FAILURE';

// Apply to become a verified provider (org owner/admin only).
export const PROVIDER_APPLY_REQUEST = ns + '_PROVIDER_APPLY_REQUEST';
export const PROVIDER_APPLY_SUCCESS = ns + '_PROVIDER_APPLY_SUCCESS';
export const PROVIDER_APPLY_FAILURE = ns + '_PROVIDER_APPLY_FAILURE';

export const CLEAR_MUTATIONS = ns + '_CLEAR_MUTATIONS';

// ---- action creators ----------------------------------------------------
export const fetchListings   = (filters = {}) => ({ type: LIST_REQUEST,    payload: { filters } });
export const fetchListing    = (listingId)    => ({ type: DETAIL_REQUEST,  payload: { listingId } });
export const fetchPreview    = (listingId, limit = 100) =>
                                ({ type: PREVIEW_REQUEST, payload: { listingId, limit } });

export const createListing   = (body)         => ({ type: CREATE_REQUEST,  payload: { body } });
export const updateListing   = (listingId, body) =>
                                ({ type: UPDATE_REQUEST,  payload: { listingId, body } });
export const deleteListing   = (listingId, force = false) =>
                                ({ type: DELETE_REQUEST,  payload: { listingId, force } });

export const subscribe       = (listingId)    => ({ type: SUBSCRIBE_REQUEST, payload: { listingId } });
export const cancelSubscribe = (subscriptionId) => ({ type: CANCEL_REQUEST,  payload: { subscriptionId } });
export const fetchSubscriptions = () => ({ type: SUBSCRIPTIONS_REQUEST });

export const fetchMyListings = () => ({ type: MY_LISTINGS_REQUEST });
export const fetchEarnings   = () => ({ type: EARNINGS_REQUEST });

export const fetchPublishedSignals = () => ({ type: PUBLISHED_SIGNALS_REQUEST });

export const fetchSellerStatus = () => ({ type: SELLER_STATUS_REQUEST });
export const applyForProvider = (body) =>
  ({ type: PROVIDER_APPLY_REQUEST, payload: { body } });

export const clearMutations  = () => ({ type: CLEAR_MUTATIONS });
